export const paArray = {
    unique(arr) {
        return $.grep(arr, function (v, k) {
            return $.inArray(v, arr) === k;
        });
    },
    shuffle(arr) {
        for (let j, x, i = arr.length; i; j = parseInt(Math.random() * i), x = arr[--i], arr[i] = arr[j], arr[j] = x) ;
        return arr;
    },
    clean(actual) {
        let newArray = new Array();
        for (let i = 0; i < actual.length; i++) {
            if (actual[i]) newArray.push(actual[i]);
        }
        return newArray;
    },
    copy(arr) {
        return [...arr];
    },
    chunk(array, chunkSize) {
        let rest = array.length % chunkSize, // how much to divide
            restUsed = rest, // to keep track of the division over the elements
            partLength = Math.floor(array.length / chunkSize),
            result = [];

        for (let i = 0; i < array.length; i += partLength) {
            let end = partLength + i,
                add = false;

            if (rest !== 0 && restUsed) { // should add one element for the division
                end++;
                restUsed--; // we've used one division element now
                add = true;
            }

            result.push(array.slice(i, end)); // part of the array

            if (add) {
                i++; // also increment i in the case we added an extra element for division
            }
        }

        return result;
    },
    is(arrayWannabe) {
        return Object.prototype.toString.call(arrayWannabe) === '[object Array]';
    }
};


// WEBPACK FOOTER //
// ./src/js/framework/helpers/paArray.js